import { paymentSubscriptionUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'
//
//Always get current restaurant from the store
//
async function updatePaymentSubscriptionByRestaurant(data) {

    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${paymentSubscriptionUrl}/${restaurantid}`;
    data.restaurantId = restaurantid;
    await common.putData(url, data)
                .then( () => {return true} )
                .catch( (err) => {
                    console.log(err);
                    return false;
                });

}


export default {
    name: 'paymentSubscriptionService',
    updatePaymentSubscriptionByRestaurant
}